"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-four/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BannerSectionAvatarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient24.jpg" | "/Templates/Doccure/img/patients/patient25.jpg" | "/Templates/Doccure/img/patients/patient26.jpg" | "/Templates/Doccure/img/patients/patient27.jpg" */
    src: string;
    /** Detected variants: "avatar" */
    className?: string;
    /** Detected variants: "patient" */
    alt?: string;
    /** Detected variants: "img-fluid rounded-circle" */
    imageWithBasePath0ClassName?: string;
};
export type HomeFourBannerSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "More then 25K clients" */
    sectionDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "reviews" */
    sectionDiv0Div0Div0Div0Div0P0Span0SpanText?: ReactNode;
    /** Default: "A Safe Care for your Children’s Health with" */
    sectionDiv0Div0Div0Div0Div1H10H1Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div1H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0Div1H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Nutrition’s" */
    sectionDiv0Div0Div0Div0Div1H10Span0SpanText?: ReactNode;
    /** Default: "all_routes.search1" */
    sectionDiv0Div0Div0Div0Div1Link0LinkHref?: string;
    /** Default: "View More Services" */
    sectionDiv0Div0Div0Div0Div1Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Trusted pediatric consultation for infants, children, and teens, where compassion meets expertise." */
    sectionDiv0Div0Div0Div0Div1P0PText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "banner" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/padiatrics-banner.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-bg-02.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-bg-03.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionAvatars: BannerSectionAvatarsItem[];
    bannerSectionAvatarsItemWrapper?: (item: BannerSectionAvatarsItem, content: ReactNode) => ReactNode;
    bannerSectionAvatarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarsImageVisible?: boolean;
    bannerSectionAvatarsImageRenderer?: (item: BannerSectionAvatarsItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeFourBannerSectionGenerated: FC<HomeFourBannerSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0P0PText = "More then 25K clients",
    sectionDiv0Div0Div0Div0Div0P0Span0SpanText = "reviews",
    sectionDiv0Div0Div0Div0Div1H10H1Text = "A Safe Care for your Children’s Health with",
    sectionDiv0Div0Div0Div0Div1H10H1Visible,
    sectionDiv0Div0Div0Div0Div1H10H1Renderer,
    sectionDiv0Div0Div0Div0Div1H10H1Props,
    sectionDiv0Div0Div0Div0Div1H10Span0SpanText = "Nutrition’s",
    sectionDiv0Div0Div0Div0Div1Link0LinkHref = "all_routes.search1",
    sectionDiv0Div0Div0Div0Div1Link0LinkText = "View More Services",
    sectionDiv0Div0Div0Div0Div1Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div1Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div1Link0LinkProps,
    sectionDiv0Div0Div0Div0Div1P0PText = "Trusted pediatric consultation for infants, children, and teens, where compassion meets expertise.",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/padiatrics-banner.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt = "bg",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-bg-02.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt = "bg",
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-bg-03.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    bannerSectionAvatars,
    bannerSectionAvatarsItemWrapper,
    bannerSectionAvatarsRenderer,
    bannerSectionAvatarsImageVisible,
    bannerSectionAvatarsImageRenderer,
    bannerSectionAvatarsImageProps,
}) => {
    return (
        <section className="banner-section-four">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-end"}>
                    <div className="col-xl-7 col-lg-7">
                        <div className="banner-content wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="banner-users">
                                <div className="avatar-list-stacked avatar-group-lg">
                                    {renderCollectionNode(
                                        bannerSectionAvatars,
                                        (item: BannerSectionAvatarsItem) => (
                                            <span className={item.className ?? "avatar"} key={item.key}>
                                                {renderItemNode(bannerSectionAvatarsImageVisible, bannerSectionAvatarsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "patient"} className={item.imageWithBasePath0ClassName ?? "img-fluid rounded-circle"} {...(typeof bannerSectionAvatarsImageProps === "function" ? bannerSectionAvatarsImageProps(item) : (bannerSectionAvatarsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        bannerSectionAvatarsItemWrapper,
                                        bannerSectionAvatarsRenderer
                                    )}
                                </div>
                                <p>
                                    {sectionDiv0Div0Div0Div0Div0P0PText}
                                    <span>{sectionDiv0Div0Div0Div0Div0P0Span0SpanText}</span>
                                </p>
                            </div>
                            <div>
                                {renderNode(sectionDiv0Div0Div0Div0Div1H10H1Visible, sectionDiv0Div0Div0Div0Div1H10H1Renderer, (
                                    <h1 {...(sectionDiv0Div0Div0Div0Div1H10H1Props ?? {})}>
                                        {sectionDiv0Div0Div0Div0Div1H10H1Text}
                                        {" "}
                                        <span>{sectionDiv0Div0Div0Div0Div1H10Span0SpanText}</span>
                                    </h1>
                                ))}
                                <p className="sub-title">{sectionDiv0Div0Div0Div0Div1P0PText}</p>
                                {renderNode(sectionDiv0Div0Div0Div0Div1Link0LinkVisible, sectionDiv0Div0Div0Div0Div1Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div1Link0LinkHref} className="btn btn-white" {...(sectionDiv0Div0Div0Div0Div1Link0LinkProps ?? {})}>
                                        {sectionDiv0Div0Div0Div0Div1Link0LinkText}
                                        <i className="isax isax-arrow-right-1 ms-2" />
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-5">
                        <div className="banner-img wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} className="img-fluid banner-image" alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc} className="img-fluid banner-bg-02" alt={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt} {...(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath2ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath2ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath2ImageSrc} className="img-fluid banner-bg-03" alt={sectionDiv0Div0Div1Div0ImageWithBasePath2ImageAlt} {...(sectionDiv0Div0Div1Div0ImageWithBasePath2ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeFourBannerSectionGenerated;
